/**
 * Authentication Service
 * Handles all authentication-related API calls
 * Tokens are managed via httpOnly cookies — no client-side token storage
 */

import BaseService from "../api/BaseService";
import { API_ENDPOINTS } from "utils/constants";
import storage from "utils/storage";

class AuthService extends BaseService {
  constructor() {
    super(API_ENDPOINTS.AUTH.LOGIN);
  }

  async login(credentials) {
    const response = await this.post(API_ENDPOINTS.AUTH.LOGIN, credentials);

    if (response.success && response.data?.user) {
      storage.auth.setUser(response.data.user);
    }

    return response;
  }

  async signup(userData) {
    const response = await this.post(API_ENDPOINTS.AUTH.SIGNUP, userData);

    if (response.success && response.data?.user) {
      storage.auth.setUser(response.data.user);
    }

    return response;
  }

  async logout() {
    try {
      await this.post(API_ENDPOINTS.AUTH.LOGOUT, {});
    } finally {
      storage.auth.clearAuth();
    }

    return { success: true };
  }

  async refreshToken() {
    const response = await this.post(API_ENDPOINTS.AUTH.REFRESH, {});
    return response;
  }

  async forgotPassword(email) {
    return this.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
  }

  async resetPassword(token, newPassword) {
    return this.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, {
      token,
      password: newPassword,
    });
  }

  async verifyEmail(token) {
    return this.post(API_ENDPOINTS.AUTH.VERIFY_EMAIL, { token });
  }

  async resendVerification(email) {
    return this.post(API_ENDPOINTS.AUTH.RESEND_VERIFICATION, { email });
  }

  isAuthenticated() {
    return !!storage.auth.getUser();
  }

  getCurrentUser() {
    return storage.auth.getUser();
  }

  getToken() {
    return null; // tokens are httpOnly cookies
  }

  updateCurrentUser(userData) {
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      storage.auth.setUser({ ...currentUser, ...userData });
    }
  }
}

export default new AuthService();
